import { useCallback, useState } from 'react';

import { getFormTemplateRequest } from '@vyce/core/src/api/forms';
import type { FormTemplateDoc } from '@vyce/core/src/api/types';

export const useFormTemplateData = ({ userId, companyId }: { userId: string; companyId: string }) => {
  const [template, setTemplate] = useState<FormTemplateDoc | null>(null);
  const [loading, setLoading] = useState(false);

  const getTemplate = useCallback(
    async (templateId: string) => {
      if (!companyId || !userId) return;
      try {
        setLoading(true);
        const res = await getFormTemplateRequest({ companyId, templateId, userId });
        setTemplate(res);
      } catch (error) {
        console.error(error);
        setTemplate(null);
      } finally {
        setLoading(false);
      }
    },
    [companyId, userId]
  );

  return { template, loading, getTemplate };
};
